import PropTypes from "prop-types";

import DynamicLevelPreview from "@/components/Elements/FieldPreview/DynamicLevelPreview";
import { useGetObservationRiskMatrix } from "@/entities/observation";

export const TableCellRiskMatrix = ({ observation, field }) => {
  const { isLoading, ...risk } = useGetObservationRiskMatrix(observation);

  return (
    <DynamicLevelPreview
      loading={isLoading}
      field={field}
      level={risk[field]}
    />
  );
};

TableCellRiskMatrix.propTypes = {
  observation: PropTypes.object.isRequired,
  field: PropTypes.oneOf(["probability", "consequence"]).isRequired,
};
